import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  en: {
    translation: {
      // Header
      header: {
        home: "Home",
        products: "Products",
        orders: "My Orders",
        contact: "Contact",
        login: "Login",
        logout: "Logout",
        cart: "Cart",
        search: "Search",
        favorites: "Favorites",
        language: "Language"
      },
      // Home Page
      home: {
        heroTitle1: "KUKLA",
        heroSubtitle1: "Bold colors and standout manicure with a modern, self-expression style.",
        heroTitle2: "PINK HOUSE",
        heroSubtitle2: "Delicate pink manicure, clean and elegant style for everyday feminine looks.",
        heroTitle3: "NARTIST",
        heroSubtitle3: "Creative manicure focused on details and style inspired by imagination.",
        heroCta: "Explore the collection",
        seeAll: "See all",
        loading: "Loading..."
     },
      // Product
      product: {
        addToCart: "Add to Cart",
        inStock: "In Stock",
        outOfStock: "Out of Stock",
        price: "Price",
        description: "Description",
        details: "Details",
        quantity: "Quantity",
        addToFavorites: "Add to Favorites",
        removeFromFavorites: "Remove from Favorites",
        onlyLeft: "Only {{count}} left!",
        uncategorized: "Uncategorized",
        viewDetails: "View Details"
      },
      // Favorites
      favorites: {
        title: "My Favorites",
        subtitle: "{{count}} items",
        empty: "Your favorites is empty",
        emptyDescription: "Add products to your favorites to save them for later",
        clearAll: "Clear All",
        remove: "Remove",
        confirmClear: "Are you sure you want to remove all items from favorites?"
        },
      // Cart
      cart: {
        title: "Shopping Cart",
        empty: "Your cart is empty",
        continueShopping: "Continue Shopping",
        subtotal: "Subtotal",
        total: "Total",
        checkout: "Checkout",
        remove: "Remove",
        quantity: "Quantity",
        summary: "Summary",
        items: "Item"
      },
      // Checkout
      checkout: {
        title: "Checkout",
        subtitle: "Complete your order",
        contactInfo: "Contact Information",
        firstName: "First Name",
        lastName: "Last Name",
        email: "Email",
        phone: "Phone",
        address: "Address",
        city: "City",
        paymentMethod: "Payment Method",
        placeOrder: "Place Order",
        orderSummary: "Order Summary",
        pay: "Pay",
        wait: "Wait...",
        quantity: "Quantity"
      },
      // Auth
      auth: {
        login: "Login",
        register: "Register",
        email: "Email",
        password: "Password",
        confirmPassword: "Confirm Password",
        name: "Name",
        forgotPassword: "Forgot Password?",
        dontHaveAccount: "Don't have an account?",
        alreadyHaveAccount: "Already have an account?",
        signIn: "Sign In",
        signUp: "Sign Up"
      },
      // Common
      common: {
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        edit: "Edit",
        close: "Close",
        confirm: "Confirm",
        yes: "Yes",
        no: "No",
        back: "Back",
        next: "Next",
        submit: "Submit"
      },
      // Filter
      filter: {
        placeholder: "Product...",
        category: "Category",
        price: "Price",
        apply: "Apply",
        clear: "Clear",
        min: "Min.",
        max: "Max.",
        allProducts: "All products",
        brands: "Brands",
        allBrands: "All Brands"
     },
     orders: {
        title: "My Orders",
        date: "Date",
        orderId: "Order",
        total: "Total",
        paymentMethod: "Payment Method",
        pending: "Pending",
        confirmed: "Confirmed",
        noOrders: "You have no orders yet",
        noOrdersDescription: "Start shopping and your orders will appear here"
     },
     // Terms and Conditions
     terms: {
        title: "Terms and Conditions",
        lastUpdated: "Last Updated",
        date: "January 2025",
        welcome: "Welcome to BeautyPro.ge! By using our website, you agree to these terms and conditions. Please read them carefully before making a purchase.",
        section1: {
          title: "1. General Terms",
          content1: "These Terms and Conditions govern your use of the BeautyPro.ge website and the purchase of products.",
          content2: "By placing an order, you confirm that you have read and accepted all terms and conditions.",
          content3: "We reserve the right to change these terms at any time without prior notice."
        },
        section2: {
          title: "2. Products and Services",
          content1: "We offer high-quality manicure and pedicure products, including:",
          item1: "Nail polishes and gel polishes",
          item2: "Nail care accessories",
          item3: "Professional tools",
          item4: "Salon equipment",
          content2: "All products are manufactured to the highest quality standards and tested for safety."
        },
        section3: {
          title: "3. Orders and Payments",
          content1: "An order is considered confirmed only after payment has been processed.",
          content2: "We accept payment by card.",
          content3: "Prices are listed in Georgian Lari (₾)."
        },
        section4: {
          title: "4. Shipping and Delivery",
          content1: "Delivery in Tbilisi takes 1-2 business days.",
          content2: "Regional delivery takes 3-5 business days.",
        },
        section5: {
          title: "5. Returns and Refunds",
          content1: "Products can be returned under the following conditions:",
          item1: "Product is damaged or defective",
          item2: "Wrong product was delivered",
          item3: "Returns must be made within 14 days of receipt",
          content2: "Opened and used products cannot be returned due to hygiene requirements."
        },
        section6: {
          title: "6. User Accounts",
          content1: "By creating an account, you are responsible for the security of your credentials.",
          content2: "It is prohibited to create or use an account on behalf of another person.",
          content3: "In case of suspicious activity, we reserve the right to block or delete your account."
        },
        section7: {
          title: "7. Privacy and Data Protection",
          content1: "We protect your personal data in accordance with Georgian legislation.",
          content2: "For detailed information, please see our Privacy Policy."
        },
        section8: {
          title: "8. Intellectual Property",
          content1: "All content, including logos, images, and text, is the property of BeautyPro.ge.",
          content2: "Use of any material without written permission is prohibited."
        },
        section9: {
          title: "9. Limitation of Liability",
          content1: "BeautyPro.ge is not liable for indirect damages that may arise from the use of products.",
          content2: "Our liability is limited to the value of the product."
        },
        section10: {
          title: "10. Contact Information",
          content1: "If you have any questions, please contact us:",
          email: "Email",
          phone: "Phone",
          address: "Address",
          addressValue: "Tbilisi, Georgia"
        },
        footer: "By reading and accepting these terms, you confirm that you have read and agree to all BeautyPro.ge terms and conditions."
      },
      // Privacy Policy
      privacy: {
        title: "Privacy Policy",
        lastUpdated: "Last Updated",
        date: "January 2025",
        welcome: "At BeautyPro.ge, we are committed to protecting your privacy. This Privacy Policy explains how we collect, use, and protect your personal information.",
        section1: {
          title: "1. Information We Collect",
          content1: "We collect the following types of information when you use our website:",
          subtitle1: "Personal Information:",
          item1: "Name and contact details (email, phone, address)",
          item2: "Billing and shipping information",
          item3: "Payment card information (processed securely)",
          item4: "Account credentials (username and password)",
          subtitle2: "Usage Information:",
          item5: "Pages visited and products viewed",
          item6: "Device information (IP address, browser type)",
          item7: "Cookies and similar tracking technologies"
        },
        section2: {
          title: "2. How We Use Your Information",
          content1: "We use your personal information for the following purposes:",
          item1: "Processing and fulfilling your orders",
          item2: "Communicating with you about your orders and account",
          item3: "Improving our website and customer service",
          item4: "Sending promotional emails (with your consent)",
          item5: "Preventing fraud and ensuring security"
        },
        section3: {
          title: "3. Data Storage and Security",
          content1: "We implement industry-standard security measures to protect your personal data from unauthorized access, disclosure, or misuse.",
          content2: "Your payment information is encrypted using SSL technology and processed by secure payment providers.",
          content3: "We retain your personal data only as long as necessary to fulfill the purposes described in this policy or as required by law."
        },
        section4: {
          title: "4. Sharing Your Information",
          content1: "We do not sell or rent your personal information to third parties. We may share your information with:",
          item1: "Payment processors to complete transactions",
          item2: "Shipping companies to deliver your orders",
          item3: "Service providers who help us operate our website",
          content2: "All third parties are required to protect your data and use it only for the purposes we specify."
        },
        section5: {
          title: "5. Cookies and Tracking Technologies",
          content1: "We use cookies and similar technologies to:",
          item1: "Remember your preferences and settings",
          item2: "Analyze website traffic and usage patterns",
          item3: "Personalize your shopping experience",
          content2: "You can control cookies through your browser settings. Disabling cookies may affect website functionality."
        },
        section6: {
          title: "6. Your Rights",
          content1: "You have the following rights regarding your personal data:",
          item1: "Access: Request a copy of your personal data",
          item2: "Correction: Update or correct inaccurate information",
          item3: "Deletion: Request deletion of your personal data",
          item4: "Objection: Object to certain data processing activities",
          item5: "Portability: Receive your data in a portable format",
          content2: "To exercise these rights, please contact us using the information below."
        },
        section7: {
          title: "7. Children's Privacy",
          content1: "Our website is not intended for children under 18 years of age. We do not knowingly collect personal information from children.",
          content2: "If we learn that we have collected information from a child, we will delete it immediately."
        },
        section8: {
          title: "8. Third-Party Links",
          content1: "Our website may contain links to third-party websites. We are not responsible for the privacy practices of these websites.",
          content2: "We encourage you to read the privacy policies of any third-party sites you visit."
        },
        section9: {
          title: "9. Changes to This Privacy Policy",
          content1: "We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated revision date.",
          content2: "We encourage you to review this policy periodically to stay informed about how we protect your information."
        },
        section10: {
          title: "10. Contact Us",
          content1: "If you have any questions or concerns about this Privacy Policy, please contact us:",
          email: "Email",
          phone: "Phone",
          address: "Address",
          addressValue: "Tbilisi, Georgia"
        },
        footer: "By using BeautyPro.ge, you consent to the collection and use of your information as described in this Privacy Policy."
      },
      // Return Policy
      returnPolicy: {
  title: "Return & Refund Policy",
  lastUpdated: "Last updated",
  date: "January 2025",
  welcome:
    "At BeautyPro.ge, customer satisfaction is our priority. We offer a simple and transparent return policy to ensure confidence in your purchase.",
  section1: {
    title: "1. Return Period",
    content1:
      "Customers have the right to return or exchange products purchased from Beauty Pro within 14 calendar days from the date of delivery.",
    content2:
      "The return period is calculated from the day the order is actually received.",
    important: "Important:",
    content3:
      "Products must be returned within this 14-day period in order to be eligible for a refund or exchange."
  },
  section2: {
    title: "2. Conditions for Product Exchange",
    content1: "Products are eligible for exchange in the following cases:",
    item1: "The product was delivered damaged or defective",
    item2: "An incorrect product was delivered",
    item3: "The product does not match the description",
    item4:
      "The customer decides to exchange the product for a similar model within 14 days, provided that the product is unopened, unused, and retains its original commercial appearance."
  },
  section3: {
    title: "3. Non-Returnable Products",
    content1:
      "For hygiene and safety reasons, the following products cannot be returned:",
    item1: "Opened or used cosmetic products",
    item2: "Products with damaged seals or packaging",
    item3: "Final sale or discounted products",
    item4: "Gift cards or promotional products"
  },
  section4: {
    title: "4. How to Return a Product",
    content1:
      "To return or exchange a product, the customer must first contact the Beauty Pro support team and provide the following information:",
    step1Title: "Order number",
    step2Title: "Order and delivery date",
    step3Title: "Reason for return"
  },
  section5: {
    title:
      "5. Beauty Pro commits to refunding the paid amount under the following conditions:",
    content1:
      "100% refund — if the product is unopened, undamaged, and in full original packaging",
    content2:
      "100% refund — in cases of manufacturing defects, incorrect delivery, or damage during transportation",
    content3:
      "Partial refund (90–100%) — if the packaging has been opened but the product remains fully functional and visually intact",
    note:
      "If, after inspection, it is determined that the product has lost its functional or visual characteristics or is missing parts of the original packaging, Beauty Pro reserves the right to refuse the refund.",
    content4:
      "Partial refund (60–80%) — if the packaging is damaged or the product shows visible defects"
  },
  section6: {
    title: "6. Exchange Policy",
    content1:
      "Manicure products are not eligible for exchange. The return policy applies to all products except nail polishes, gel polishes, and single-use products.",
    content2:
      "Product exchanges are subject to availability.",
    content3:
      "We will arrange shipment of the replacement product once the returned item has been received."
  },
  section7: {
    title: "7. Return Shipping Costs",
    content1:
      "Beauty Pro covers return shipping costs if:",
    item1: "The product does not match the order",
    item2:
      "The product has a manufacturing defect or was damaged during transportation"
  },
  section8: {
    title: "8. Refund Process",
    content1:
      "Refunds are processed via non-cash payment only, using the same payment method used for the original purchase.",
    content2:
      "Refunds are issued within 5 business days after the returned product has been received and inspected."
  },
  section9: {
    title: "9. Contact Us for Returns",
    content1:
      "For any questions or to initiate a return, please contact us:",
    email: "Email",
    phone: "Phone",
    hours: "Business hours",
    hoursValue: "Monday – Saturday, 10:00 – 19:00"
  },
  footer:
    "By making a purchase on BeautyPro.ge, you agree to our return and refund policy. Your satisfaction is our priority!"
},
      //about us
      about: {
        title: "About Us",
        welcome: "Beauty Pro Store is a premium space that brings together quality, aesthetics, and a professional vision. Our platform is created for those who prioritize quality and flawless results. Beauty Pro Store is the official representative of KUKLA and presents premium brands that meet the high standards of the modern industry, ensure consistent results, and build partnerships based on trust, quality, and effective collaboration with specialists and salons."
      },
        shop: {
      next: "Next",
      previous: "Previous"
    },
    contact: {
        title: "Contact Us",
        subtitle: "Contact us with any questions for assistance. Our team is ready to help!",
        phone: "Phone",
        email: "Email",
        call: "Call Us →",
        send: "Send →",
        follow: "Follow Us →",
        visit: "Visit Us →",
      },
      footer: {
        rights: "All rights reserved.",
        shop: "Shop",
        contact: "Contact",
        support: "Support",
        terms: "Terms & Conditions",
        privacy: "Privacy Policy",
        refund: "Money Return Policy",
        collection: "New Collection",
        location: "Vazha Pshavela ave., II line, Building 11B, Tbilisi, Georgia",
      },
      login: {
        title: "Login",
        email: "Email",
        password: "Password",
        remember: "Remember me",
        login: "Don't Have An Account?",
        loginLink: "Register"
      },
      register: {
        title: "Create an Account",
        subtitle: "Join us and start shopping!",
        fullName: "Full Name",
        email: "Email",
        password: "Password",
        confirmPassword: "Confirm Password",
        agreeTerms: "I agree to the ",
        haveAccount: "Already have an account?",
        login: "Login",
      },
      product: {
  availability: "Availability",
  category: "Category",
  inStock: "In stock",
  outOfStock: "Out of stock",
  quantity: "Quantity",
  addToCart: "Add to cart",

  messages: {
    error: "Error",
    productNotFound: "Product Not Found",
    productNotFoundDesc: "The product you are looking for does not exist.",

    loginRequired: "Login Required",
    loginRequiredDesc: "Please login to add products to your cart.",

    success: "Success",
    addedToCart: "Added to Cart",
    addedToCartDesc: "has been added to your cart!",
  }
      },
      kidoHero: {
        welcome: "Made for\nmagical days.",
        subtitle: "Soft, joyful pieces for every little adventure.",
        cta: "Explore collection"
      }


    },
  },
  ka: {
    translation: {
      // Header
      header: {
        home: "მთავარი",
        products: "პროდუქტები",
        orders: "შეკვეთები",
        contact: "ჩვენს შესახებ",
        login: "შესვლა",
        logout: "გასვლა",
        cart: "კალათა",
        search: "ძიება",
        favorites: "ფავორიტები",
        language: "ენა"
      },
      shop: {
      next: "წინ",
      previous: "უკან"
    },
      // Home Page
      home: {
        heroTitle1: "KUKLA",
        heroSubtitle1: "თამამი ფერები და გამოკვეთილი მანიკური თანამედროვე, თვითგამოხატვის სტილით.",
        heroTitle2: "PINK HOUSE",
        heroSubtitle2: "ნაზი ვარდისფერი მანიკური, სისუფთავე, ელეგანტური სტილი ყოველდღიური და ქალური ლუქისთვის.",
        heroTitle3: "NARTIST",
        heroSubtitle3: "კრეატიული მანიკური დეტალებზე ორიენტირებული დიზაინით და შთაგონებაზე აგებული სტილით.",
        heroCta: "დაათვალიერე კოლექცია",
        seeAll: "ყველას ნახვა",
        loading: "იტვირთება..."
      },
      // Product
      product: {
        addToCart: "კალათაში დამატება",
        inStock: "მარაგშია",
        outOfStock: "არ არის მარაგში",
        price: "ფასი",
        description: "აღწერა",
        details: "დეტალები",
        quantity: "რაოდენობა",
        addToFavorites: "ფავორიტებში დამატება",
        removeFromFavorites: "ფავორიტებიდან წაშლა",
        onlyLeft: "მხოლოდ {{count}} დარჩა!",
        uncategorized: "კატეგორიის გარეშე",
        viewDetails: "დეტალების ნახვა"
      },
      // Favorites
      favorites: {
        title: "ჩემი ფავორიტები",
        subtitle: "{{count}} ნივთი",
        empty: "თქვენი ფავორიტები ცარიელია",
        emptyDescription: "დაამატეთ პროდუქტები ფავორიტებში შემდგომში შესანახად",
        clearAll: "ყველას წაშლა",
        remove: "წაშლა",
        confirmClear: "დარწმუნებული ხარ რომ ყველა ნივთის წაშლა გსურს ფავორიტებიდან?"
        },
      // Cart
      cart: {
        title: "კალათა",
        empty: "თქვენი კალათა ცარიელია",
        continueShopping: "პროდუქტების დათვალიერება",
        subtotal: "ჯამში",
        total: "სულ",
        checkout: "გადახდა",
        remove: "წაშლა",
        quantity: "რაოდენობა",
        summary: "შეჯამება",
        items: "პროდუქტი"
      },
      // Checkout
      checkout: {
        title: "გადახდა",
        subtitle: "დაასრულეთ თქვენი შეკვეთა",
        contactInfo: "საკონტაქტო ინფორმაცია",
        firstName: "სახელი",
        lastName: "გვარი",
        email: "ელ.ფოსტა",
        phone: "ტელეფონი",
        address: "მისამართი",
        city: "ქალაქი",
        paymentMethod: "გადახდის მეთოდი",
        placeOrder: "შეკვეთის დადასტურება",
        orderSummary: "შეჯამება",
        pay: "გადახდა",
        wait: "დაელოდეთ...",
        quantity: "რაოდენობა"
      },
      // Auth
      auth: {
        login: "შესვლა",
        register: "რეგისტრაცია",
        email: "ელ.ფოსტა",
        password: "პაროლი",
        confirmPassword: "დაადასტურეთ პაროლი",
        name: "სახელი",
        forgotPassword: "დაგავიწყდა პაროლი?",
        dontHaveAccount: "არ გაქვთ ანგარიში?",
        alreadyHaveAccount: "უკვე გაქვთ ანგარიში?",
        signIn: "შესვლა",
        signUp: "რეგისტრაცია"
      },
      // Common
      common: {
        save: "შენახვა",
        cancel: "გაუქმება",
        delete: "წაშლა",
        edit: "რედაქტირება",
        close: "დახურვა",
        confirm: "დადასტურება",
        yes: "კი",
        no: "არა",
        back: "უკან",
        next: "შემდეგი",
        submit: "გაგზავნა"
      },
      // Filter
      filter: {
        placeholder: "პროდუქტი...",
        category: "კატეგორია",
        price: "ფასი",
        apply: "გაფილტვრა",
        clear: "გასუფთავება",
        min: "მინ.",
        max: "მაქს.",
        allProducts: "ყველა პროდუქტი",
        brands: "ბრენდები",
        allBrands: "ყველა ბრენდი"
     },
     orders: {
        title: "ჩემი შეკვეთები",
        date: "თარიღი",
        orderId: "შეკვეთა",
        total: "ჯამში",
        paymentMethod: "გადახდის მეთოდი",
        pending: "მუშავდება",
        confirmed: "დადასტურებული",
        noOrders: "ჯერ არაფერი შეკვეთილი არ არის",
        noOrdersDescription: "დაიწყეთ შოპინგი და თქვენი შეკვეთები აქ მოჩნდება"
     },
     // Terms and Conditions
     terms: {
        title: "წესები და პირობები",
        lastUpdated: "ბოლო განახლება",
        date: "2025 წლის იანვარი",
        welcome: "BeautyPro.ge-ზე კეთილი იყოს თქვენი მობრძანება! ჩვენი ვებსაიტის გამოყენებით, თქვენ ეთანხმებით შემდეგ წესებსა და პირობებს. გთხოვთ, ყურადღებით წაიკითხოთ ისინი შესყიდვამდე.",
        section1: {
          title: "1. ზოგადი დებულებები",
          content1: "ეს წესები და პირობები არეგულირებს თქვენს BeautyPro.ge ვებსაიტის გამოყენებას და პროდუქტების შეძენას.",
          content2: "შესყიდვის განხორციელებით, თქვენ ადასტურებთ, რომ გაეცანით და მიიღეთ ყველა წესი და პირობა.",
          content3: "ჩვენ ვიტოვებთ უფლებას, შევცვალოთ ეს პირობები ნებისმიერ დროს, წინასწარი შეტყობინების გარეშე."
        },
        section2: {
          title: "2. პროდუქტები და სერვისები",
          content1: "ჩვენ ვთავაზობთ მაღალი ხარისხის მანიკიურისა და პედიკიურის პროდუქტებს, მათ შორის:",
          item1: "ლაქები და გელ-ლაქები",
          item2: "ფრჩხილების მოვლის აქსესუარები",
          item3: "პროფესიონალური ხელსაწყოები",
          item4: "სალონის აღჭურვილობა",
          content2: "ყველა პროდუქტი დამზადებულია უმაღლესი ხარისხის სტანდარტების მიხედვით და შემოწმებულია უსაფრთხოებაზე."
        },
        section3: {
          title: "3. შეკვეთები და გადახდები",
          content1: "შეკვეთა ითვლება დადასტურებულად მხოლოდ გადახდის განხორციელების შემდეგ.",
          content2: "ჩვენ ვიღებთ გადახდას ბარათით.",
          content3: "ფასები მოცემულია ლარში (₾)."
        },
        section4: {
          title: "4. მიწოდება და ტრანსპორტირება",
          content1: "მიწოდება ხორციელდება თბილისში 1-2 სამუშაო დღის განმავლობაში.",
          content2: "რეგიონებში მიწოდება ხორციელდება 3-5 სამუშაო დღის განმავლობაში.",
        },
        section5: {
          title: "5. დაბრუნება და თანხის უკან დაბრუნება",
          content1: "პროდუქტის დაბრუნება შესაძლებელია შემდეგ პირობებში:",
          item1: "პროდუქტი დაზიანებულია ან დეფექტურია",
          item2: "არასწორი პროდუქტი იყო მიწოდებული",
          item3: "დაბრუნება განხორციელდება მიღებიდან 14 დღის განმავლობაში",
          content2: "გახსნილი და გამოყენებული პროდუქტების დაბრუნება არ ხდება ჰიგიენის მოთხოვნების გამო."
        },
        section6: {
          title: "6. მომხმარებლის ანგარიში",
          content1: "ანგარიშის შექმნით, თქვენ პასუხისმგებელი ხართ თქვენი საიდუმლო ინფორმაციის უსაფრთხოებაზე.",
          content2: "აკრძალულია სხვა პირის სახელით ანგარიშის შექმნა ან გამოყენება.",
          content3: "საეჭვო აქტივობის შემთხვევაში ჩვენ უფლება გვაქვს დავბლოკოთ ან წავშალოთ თქვენი ანგარიში."
        },
        section7: {
          title: "7. კონფიდენციალურობა და მონაცემთა დაცვა",
          content1: "ჩვენ ვიცავთ თქვენს პერსონალურ მონაცემებს საქართველოს კანონმდებლობის შესაბამისად.",
          content2: "დეტალური ინფორმაციისთვის გთხოვთ, იხილოთ ჩვენი კონფიდენციალურობის პოლიტიკა."
        },
        section8: {
          title: "8. ინტელექტუალური საკუთრება",
          content1: "ყველა კონტენტი, მათ შორის ლოგო, სურათები და ტექსტი, BeautyPro.ge-ს საკუთრებაა.",
          content2: "აკრძალულია ნებისმიერი მასალის გამოყენება წერილობითი ნებართვის გარეშე."
        },
        section9: {
          title: "9. პასუხისმგებლობის შეზღუდვა",
          content1: "BeautyPro.ge არ არის პასუხისმგებელი არაპირდაპირი ზიანისთვის, რომელიც შეიძლება გამოწვეულ იქნას პროდუქტების გამოყენებით.",
          content2: "ჩვენი პასუხისმგებლობა შემოიფარგლება პროდუქტის ღირებულებით."
        },
        section10: {
          title: "10. საკონტაქტო ინფორმაცია",
          content1: "კითხვების შემთხვევაში, გთხოვთ დაგვიკავშირდით:",
          email: "ელ-ფოსტა",
          phone: "ტელეფონი",
          address: "მისამართი",
          addressValue: "თბილისი, საქართველო"
        },
        footer: "ამ პირობების წაკითხვითა და მიღებით, თქვენ ადასტურებთ, რომ გაეცანით და დაეთანხმეთ BeautyPro.ge-ს ყველა წესს და პირობას."
      },
      // Privacy Policy
      privacy: {
        title: "კონფიდენციალურობის პოლიტიკა",
        lastUpdated: "ბოლო განახლება",
        date: "2025 წლის იანვარი",
        welcome: "BeautyPro.ge-ზე ჩვენ ვზრუნავთ თქვენი კონფიდენციალურობის დაცვაზე. ეს პოლიტიკა განმარტავს, თუ როგორ ვაგროვებთ, ვიყენებთ და ვიცავთ თქვენს პერსონალურ ინფორმაციას.",
        section1: {
          title: "1. ინფორმაცია, რომელსაც ვაგროვებთ",
          content1: "ჩვენ ვაგროვებთ შემდეგი ტიპის ინფორმაციას, როდესაც იყენებთ ჩვენს ვებსაიტს:",
          subtitle1: "პერსონალური ინფორმაცია:",
          item1: "სახელი და საკონტაქტო დეტალები (ელ-ფოსტა, ტელეფონი, მისამართი)",
          item2: "ბილინგისა და მიწოდების ინფორმაცია",
          item3: "საგადახდო ბარათის ინფორმაცია (უსაფრთხოდ დამუშავებული)",
          item4: "ანგარიშის მონაცემები (მომხმარებლის სახელი და პაროლი)",
          subtitle2: "გამოყენების ინფორმაცია:",
          item5: "მონახულებული გვერდები და ნანახი პროდუქტები",
          item6: "მოწყობილობის ინფორმაცია (IP მისამართი, ბრაუზერის ტიპი)",
          item7: "ქუქი ფაილები და მსგავსი ტექნოლოგიები"
        },
        section2: {
          title: "2. როგორ ვიყენებთ თქვენს ინფორმაციას",
          content1: "ჩვენ ვიყენებთ თქვენს პერსონალურ ინფორმაციას შემდეგი მიზნებისთვის:",
          item1: "თქვენი შეკვეთების დამუშავება და შესრულება",
          item2: "კომუნიკაცია თქვენს შეკვეთებთან და ანგარიშთან დაკავშირებით",
          item3: "ჩვენი ვებსაიტისა და მომსახურების გაუმჯობესება",
          item4: "სარეკლამო ელ-ფოსტების გაგზავნა (თქვენი თანხმობით)",
          item5: "თაღლითობის პრევენცია და უსაფრთხოების უზრუნველყოფა"
        },
        section3: {
          title: "3. მონაცემთა შენახვა და უსაფრთხოება",
          content1: "ჩვენ ვიყენებთ ინდუსტრიის სტანდარტულ უსაფრთხოების ზომებს თქვენი პერსონალური მონაცემების დაუშვებელი წვდომისგან, გამჟღავნებისგან ან არასწორი გამოყენებისგან დასაცავად.",
          content2: "თქვენი საგადახდო ინფორმაცია დაშიფრულია SSL ტექნოლოგიის გამოყენებით და დამუშავებულია უსაფრთხო გადახდის პროვაიდერების მიერ.",
          content3: "ჩვენ ვინახავთ თქვენს პერსონალურ მონაცემებს მხოლოდ იმ პერიოდში, რაც საჭიროა ამ პოლიტიკაში აღწერილი მიზნების შესასრულებლად ან კანონით მოთხოვნილი პერიოდის განმავლობაში."
        },
        section4: {
          title: "4. თქვენი ინფორმაციის გაზიარება",
          content1: "ჩვენ არ ვყიდით და არ ვაქირავებთ თქვენს პერსონალურ ინფორმაციას მესამე მხარეებთან. ჩვენ შეიძლება გავაზიაროთ თქვენი ინფორმაცია:",
          item1: "გადახდის პროცესორებთან ტრანზაქციების დასასრულებლად",
          item2: "მიწოდების კომპანიებთან თქვენი შეკვეთების მისატანად",
          item3: "სერვისის პროვაიდერებთან, რომლებიც გვეხმარებიან ვებსაიტის ფუნქციონირებაში",
          content2: "ყველა მესამე მხარე ვალდებულია დაიცვას თქვენი მონაცემები და გამოიყენოს ისინი მხოლოდ ჩვენს მიერ მითითებული მიზნებისთვის."
        },
        section5: {
          title: "5. ქუქი ფაილები და თვალთვალის ტექნოლოგიები",
          content1: "ჩვენ ვიყენებთ ქუქი ფაილებსა და მსგავს ტექნოლოგიებს:",
          item1: "თქვენი პრეფერენციებისა და პარამეტრების დასამახსოვრებლად",
          item2: "ვებსაიტის ტრაფიკისა და გამოყენების შესწავლისთვის",
          item3: "თქვენი შოპინგის გამოცდილების პერსონალიზაციისთვის",
          content2: "თქვენ შეგიძლიათ მართოთ ქუქი ფაილები თქვენი ბრაუზერის პარამეტრებიდან. ქუქი ფაილების გამორთვამ შეიძლება იმოქმედოს ვებსაიტის ფუნქციონირებაზე."
        },
        section6: {
          title: "6. თქვენი უფლებები",
          content1: "თქვენ გაქვთ შემდეგი უფლებები თქვენს პერსონალურ მონაცემებთან დაკავშირებით:",
          item1: "წვდომა: მოითხოვეთ თქვენი პერსონალური მონაცემების ასლი",
          item2: "კორექცია: განაახლეთ ან გაასწორეთ არაზუსტი ინფორმაცია",
          item3: "წაშლა: მოითხოვეთ თქვენი პერსონალური მონაცემების წაშლა",
          item4: "ნება: აპროტესტოთ გარკვეული მონაცემთა დამუშავების აქტივობები",
          item5: "პორტაბელურობა: მიიღოთ თქვენი მონაცემები პორტაბელურ ფორმატში",
          content2: "ამ უფლებების გამოსაყენებლად, გთხოვთ დაგვიკავშირდეთ ქვემოთ მოცემული ინფორმაციის გამოყენებით."
        },
        section7: {
          title: "7. ბავშვების კონფიდენციალურობა",
          content1: "ჩვენი ვებსაიტი არ არის განკუთვნილი 18 წლამდე ასაკის ბავშვებისთვის. ჩვენ შეგნებულად არ ვაგროვებთ პერსონალურ ინფორმაციას ბავშვებისგან.",
          content2: "თუ გავიგებთ, რომ შევაგროვეთ ინფორმაცია ბავშვისგან, დაუყოვნებლივ წავშლით მას."
        },
        section8: {
          title: "8. მესამე მხარის ბმულები",
          content1: "ჩვენს ვებსაიტს შეიძლება შეიცავდეს ბმულები მესამე მხარის ვებსაიტებზე. ჩვენ არ ვართ პასუხისმგებელნი ამ ვებსაიტების კონფიდენციალურობის პრაქტიკაზე.",
          content2: "ჩვენ გირჩევთ წაიკითხოთ კონფიდენციალურობის პოლიტიკა ნებისმიერი მესამე მხარის საიტისა, რომელსაც სტუმრობთ."
        },
        section9: {
          title: "9. ცვლილებები კონფიდენციალურობის პოლიტიკაში",
          content1: "ჩვენ შეიძლება დროდადრო განვაახლოთ ეს კონფიდენციალურობის პოლიტიკა. ნებისმიერი ცვლილება გამოქვეყნდება ამ გვერდზე განახლებული თარიღით.",
          content2: "ჩვენ გირჩევთ პერიოდულად გადახედოთ ამ პოლიტიკას, რათა იყოთ ინფორმირებული, თუ როგორ ვიცავთ თქვენს ინფორმაციას."
        },
        section10: {
          title: "10. დაგვიკავშირდით",
          content1: "თუ გაქვთ კითხვები ან შეშფოთება ამ კონფიდენციალურობის პოლიტიკასთან დაკავშირებით, გთხოვთ დაგვიკავშირდეთ:",
          email: "ელ-ფოსტა",
          phone: "ტელეფონი",
          address: "მისამართი",
          addressValue: "თბილისი, საქართველო"
        },
        footer: "BeautyPro.ge-ს გამოყენებით, თქვენ ეთანხმებით თქვენი ინფორმაციის შეგროვებასა და გამოყენებას, როგორც ეს აღწერილია ამ კონფიდენციალურობის პოლიტიკაში."
      },
      // Return Policy
      returnPolicy: {
        title: "ფულის დაბრუნება და დაბრუნების პოლიტიკა",
        lastUpdated: "ბოლო განახლება",
        date: "2025 წლის იანვარი",
        welcome: "BeautyPro.ge-ზე მომხმარებლის კმაყოფილება ჩვენი პრიორიტეტია. ჩვენ გთავაზობთ მარტივ დაბრუნების პოლიტიკას, რათა დარწმუნებულები იყოთ თქვენს შენაძენში.",
        section1: {
          title: "1. დაბრუნების პერიოდი",
          content1: "მომხმარებელს უფლება აქვს Beauty Pro-დან შეძენილი პროდუქცია დააბრუნოს ან გაცვალოს მიწოდების დღიდან 14 კალენდარული დღის განმავლობაში.",
          content2: "დაბრუნების ვადა ითვლება შეკვეთის ფაქტობრივი მიღების დღიდან.",
          important: "მნიშვნელოვანი:",
          content3: "პროდუქტები უნდა დაბრუნდეს ამ 14-დღიანი ვადის განმავლობაში, რათა შესაძლებელი იყოს თანხის ან გაცვლის მიღება."
        },
        section2: {
          title: "2. პროდუქციის შეცვლის პირობები",
          content1: "პროდუქცია ექვემდებარება შეცვლას შემდეგ შემთხვევებში:",
          item1: "პროდუქტი მივიდა დაზიანებული ან დეფექტური",
          item2: "არასწორი პროდუქტი იყო მიწოდებული",
          item3: "პროდუქტი არ შეესაბამება აღწერას",
          item4: "მომხმარებელმა 14 დღის ვადაში გადაწყვიტა პროდუქციის გაცვლა სხვა მსგავს მოდელში, იმ პირობით, რომ პროდუქტი არის გაუხსნელი, გამოუყენებელი და ინარჩუნებს პირვანდელ სასაქონლო იერსახეს."
        },
        section3: {
          title: "3. დაბრუნებისთვის უვარგისი პროდუქტები",
          content1: "ჰიგიენისა და უსაფრთხოების მიზეზების გამო, შემდეგი პროდუქტები ვერ დაბრუნდება:",
          item1: "გახსნილი ან გამოყენებული კოსმეტიკური პროდუქტები",
          item2: "პროდუქტები დაზიანებული ბეჭდებით ან შეფუთვით",
          item3: "საბოლოო გაყიდვის ან ფასდაკლების პროდუქტები",
          item4: "სასაჩუქრე ბარათები ან სარეკლამო პროდუქტები"
        },
        section4: {
          title: "4. როგორ დავაბრუნოთ პროდუქტი",
          content1: "პროდუქციის დაბრუნების ან გაცვლის სურვილის შემთხვევაში მომხმარებელი ვალდებულია წინასწარ დაუკავშირდეს Beauty Pro-ს საინფორმაციო გუნდს და წარმოადგინოს შემდეგი ინფორმაცია:",
          step1Title: "შეკვეთის ნომერი",
          step2Title: "შეკვეთისა და მიღების თარიღი",
          step3Title: "დაბრუნების მიზეზი",
          },
        section5: {
          title: "5. Beauty Pro იღებს ვალდებულებას მომხმარებელს აუნაზღაუროს გადახდილი თანხა შემდეგი პირობებით:",
          content1: "100% დაბრუნება — თუ პროდუქტი არის გაუხსნელი, დაუზიანებელი და სრულ კომპლექტაციაში",
          content2: "100% დაბრუნება — ქარხნული წუნის, არასწორი მიწოდების ან ტრანსპორტირებისას დაზიანების შემთხვევაში;",
          content3: "ნაწილობრივი ანაზღაურება (90–100%) — თუ შეფუთვა გახსნილია, თუმცა პროდუქტი ფუნქციურად და ვიზუალურად სრულად გამართულია;",
          note: "იმ შემთხვევაში, თუ დიაგნოსტირების შედეგად დადგინდება, რომ პროდუქტს არ აქვს შენარჩუნებული ფუნქციონალური ან ვიზუალური მახასიათებლები ან არ ახლავს სრული კომპლექტაცია, Beauty Pro იტოვებს უფლებას უარი თქვას დაბრუნებაზე.",
          content4: "ნაწილობრივი ანაზღაურება (60–80%) — თუ შეფუთვა დაზიანებულია ან აღენიშნება ვიზუალური ხარვეზი."
        },
        section6: {
          title: "6. გაცვლის პოლიტიკა",
          content1: "მანიკურის პროდუქტები არ ექვემდებარება გაცვლას, შესაბამისად დავრუნების პოლიტიკა ვრცელდება ყველაფერზე გარდა ლაქებისა, გელლაქებისა და ერთჯერადი პროდუქციისა",
          content2: "გაცვლა დამოკიდებულია პროდუქტის ხელმისაწვდომობაზე.",
          content3: "ჩვენ მოვაწყობთ ახალი პროდუქტის გამოგზავნას, როგორც კი მივიღებთ თქვენს დაბრუნებას."
        },
        section7: {
          title: "7. დაბრუნების გადაზიდვის ხარჯები",
          content1: "Beauty Pro ფარავს დაბრუნების ტრანსპორტირების ხარჯებს, თუ:",
          item1: "პროდუქტი არ შეესაბამება შეკვეთას",
          item2: "პროდუქტს აქვს ქარხნული წუნი ან დაზიანებულია ტრანსპორტირებისას",
        },
        section8: {
          title: "8. თანხის დაბრუნების პროცესი",
          content1: "თანხის დაბრუნება ხორციელდება მხოლოდ უნაღდო ანგარიშსწორებით, იმავე გადახდის მეთოდზე, რომლითაც განხორციელდა შეძენა.",
          content2: "ანაზღაურება ხდება 5 სამუშაო დღის განმავლობაში, დაბრუნებული პროდუქტის მიღებისა და შემოწმების შემდეგ.",
        },
        section9: {
          title: "9. დაგვიკავშირდით დაბრუნებისთვის",
          content1: "ნებისმიერი კითხვისთვის ან დაბრუნების დასაწყებად, გთხოვთ დაგვიკავშირდეთ:",
          email: "ელ-ფოსტა",
          phone: "ტელეფონი",
          hours: "სამუშაო საათები",
          hoursValue: "ორშაბათი - შაბათი, 10:00 - 19:00"
        },
        footer: "BeautyPro.ge-ზე შესყიდვის განხორციელებით, თქვენ ეთანხმებით ჩვენს დაბრუნებისა და თანხის დაბრუნების პოლიტიკას. ჩვენ ვართ თქვენი კმაყოფილებისთვის!"
      },
      //about us
      about: {
        title: "ჩვენს შესახებ",
        welcome: "Beauty Pro Store არის პრემიუმ სივრცე, რომელიც აერთიანებს ხარისხს, ესთეტიკას და პროფესიონალურ ხედვას. ჩვენი პლატფორმა შექმნილია მათთვის, ვისთვისაც ხარისხი და სრულყოფილი შედეგი პრიორიტეტულია. Beauty Pro Store არის KUKLA-ს ოფიციალური წარმომადგენელი და წარმოგიდგენთ პრემიუმ ბრენდებს, რომლებიც შეესაბამება თანამედროვე ინდუსტრიის მაღალ სტანდარტებს, უზრუნველყოფს სტაბილურ შედეგს და ქმნის ნდობაზე, ხარისხსა და ეფექტურ თანამშრომლობაზე დაფუძნებულ პარტნიორობას სპეციალისტებთან და სალონებთან.",
      },
      contact: {
        title: "დაგვეკონტაქტეთ",
        subtitle: "დაგვეკონტაქტე ნებისმიერი კითხვით დახმარებისთვის. ჩვენი გუნდი მზად არის დაგეხმაროთ!",
        phone: "ტელეფონი",
        email: "იმეილი",
        call: "დაგვირეკე →",
        send: "გაგზავნა →",
        follow: "გამოგვყევი →",
        visit: "ესტუმრე →",
      },
      footer: {
        rights: "ყველა წესი დაცულია.",
        shop: "დაათვალიერე",
        contact: "კონტაქტი",
        support: "დახმარება",
        terms: "წესები და პირობები",
        privacy: "კონფიდენციალურობის პოლიტიკა",
        refund: "თანხის დაბრუნების პოლიტიკა",
        collection: "ახალი კოლექცია",
        location: "ვაჟა-ფშაველას II კვარტალი, 11ბ, თბილისი, საქართველო",
      },
      login: {
        title: "შესვლა",
        email: "ელ.ფოსტა",
        password: "პაროლი",
        remember: "დამახსოვრება",
        login: "არ გაქვს ანგარიში?",
        loginLink: "რეგისტრაცია"
      },
      register: {
        title: "შექმენი ანგარიში",
        subtitle: "შემოგვიერთდი და იშოპინგე!",
        fullName: "სრული სახელი",
        email: "იმეილი",
        password: "პაროლი",
        confirmPassword: "პაროლის დადასტურება",
        agreeTerms: "მე ვეთანხმები",
        haveAccount: "უკვე გაქვს ანგარიში?",
        login: "შესვლა",
      },
      product: {
  availability: "ხელმისაწვდომობა",
  category: "კატეგორია",
  inStock: "მარაგშია",
  outOfStock: "არ არის მარაგში",
  quantity: "რაოდენობა",
  addToCart: "კალათაში დამატება",

  messages: {
    error: "შეცდომა",
    productNotFound: "პროდუქტი ვერ მოიძებნა",
    productNotFoundDesc: "თქვენ მიერ მოძიებული პროდუქტი არ არსებობს.",

    loginRequired: "ავტორიზაცია აუცილებელია",
    loginRequiredDesc: "პროდუქტის კალათაში დასამატებლად გთხოვთ შეხვიდეთ.",

    success: "წარმატება",
    addedToCart: "დაემატა კალათაში",
    addedToCartDesc: "პროდუქტი დაემატა თქვენს კალათაში!",
  }
      },
      kidoHero: {
        welcome: "ბავშვობა,\nრომელიც ფერადია.",
        subtitle: "რბილი, მხიარული და შექმნილი პატარა თავგადასავლებისთვის.",
        cta: "კოლექციის ნახვა"
      }


    },
  },
  ru: {
    translation: {
      // Header
      header: {
        home: "Главная",
        products: "Продукты",
        orders: "заказы",
        contact: "Контакты",
        login: "Войти",
        logout: "Выйти",
        cart: "Корзина",
        search: "Поиск",
        favorites: "Избранное",
        language: "Язык"
      },
      // Home Page
      home: {
        heroTitle1: "KUKLA",
        heroSubtitle1: "Яркие цвета и выразительный маникюр в современном стиле самовыражения.",
        heroTitle2: "PINK HOUSE",
        heroSubtitle2: "Нежный розовый маникюр, чистый и элегантный стиль для повседневного женственного образа.",
        heroTitle3: "NARTIST",
        heroSubtitle3: "Креативный маникюр с акцентом на детали и стиль, вдохновлённый воображением.",
        heroCta: "Просмотреть коллекцию",
        seeAll: "Смотреть все",
        loading: "Загрузка..."
    },
      // Product
      product: {
        addToCart: "Добавить в корзину",
        inStock: "В наличии",
        outOfStock: "Нет в наличии",
        price: "Цена",
        description: "Описание",
        details: "Детали",
        quantity: "Количество",
        addToFavorites: "Добавить в избранное",
        removeFromFavorites: "Удалить из избранного",
        onlyLeft: "Осталось только {{count}}!",
        uncategorized: "Без категории",
        viewDetails: "Посмотреть детали"
      },
        // Favorites
        favorites: {
            title: "Мои избранные",
            subtitle: "{{count}} товаров",
            empty: "Ваши избранные пусты",
            emptyDescription: "Добавьте товары в избранное, чтобы сохранить их на потом",
            clearAll: "Очистить все",
            remove: "Удалить",
            confirmClear: "Вы уверены, что хотите удалить все товары из избранного?"
        },
      // Cart
      cart: {
        title: "Корзина покупок",
        empty: "Ваша корзина пуста",
        continueShopping: "Продолжить покупки",
        subtotal: "Промежуточный итог",
        total: "Всего",
        checkout: "Оформить заказ",
        remove: "Удалить",
        quantity: "Количество"
      },
      // Checkout
      checkout: {
        title: "Оформление заказа",
        subtitle: "Завершите свой заказ",
        contactInfo: "Контактная информация",
        firstName: "Имя",
        lastName: "Фамилия",
        email: "Электронная почта",
        phone: "Телефон",
        address: "Адрес",
        city: "Город",
        paymentMethod: "Способ оплаты",
        placeOrder: "Оформить заказ",
        orderSummary: "Сводка заказа",
        pay: "Оплатить",
        wait: "Подождите...",
        quantity: "Количество"
    },

      // Auth
      auth: {
        login: "Войти",
        register: "Регистрация",
        email: "Эл. почта",
        password: "Пароль",
        confirmPassword: "Подтвердите пароль",
        name: "Имя",
        forgotPassword: "Забыли пароль?",
        dontHaveAccount: "Нет аккаунта?",
        alreadyHaveAccount: "Уже есть аккаунт?",
        signIn: "Войти",
        signUp: "Зарегистрироваться"
      },
      // Common
      common: {
        save: "Сохранить",
        cancel: "Отмена",
        delete: "Удалить",
        edit: "Редактировать",
        close: "Закрыть",
        confirm: "Подтвердить",
        yes: "Да",
        no: "Нет",
        back: "Назад",
        next: "Далее",
        submit: "Отправить"
      },
      // Filter
      filter: {
        placeholder: "Продукт...",
        category: "Категория",
        price: "Цена",
        apply: "Применить",
        clear: "Сбросить",
        min: "Мин.",
        max: "Макс.",
        allProducts: "Все товары",
        brands: "Бренды",
        allBrands: "Все бренды"
    },
    orders: {
        title: "Мои заказы",
        date: "Дата",
        orderId: "Заказ",
        total: "Итого",
        paymentMethod: "Способ оплаты",
        pending: "В ожидании",
        confirmed: "Подтверждено",
        noOrders: "У вас еще нет заказов",
        noOrdersDescription: "Начните покупки, и ваши заказы появятся здесь"
    },
    // Terms and Conditions
    terms: {
        title: "Правила и Условия",
        lastUpdated: "Последнее обновление",
        date: "Январь 2025",
        welcome: "Добро пожаловать на BeautyPro.ge! Используя наш веб-сайт, вы соглашаетесь с этими правилами и условиями. Пожалуйста, внимательно прочитайте их перед покупкой.",
        section1: {
          title: "1. Общие положения",
          content1: "Эти Правила и Условия регулируют использование веб-сайта BeautyPro.ge и покупку продуктов.",
          content2: "Размещая заказ, вы подтверждаете, что прочитали и приняли все правила и условия.",
          content3: "Мы оставляем за собой право изменить эти условия в любое время без предварительного уведомления."
        },
        section2: {
          title: "2. Продукты и Услуги",
          content1: "Мы предлагаем высококачественные продукты для маникюра и педикюра, включая:",
          item1: "Лаки и гель-лаки для ногтей",
          item2: "Аксессуары для ухода за ногтями",
          item3: "Профессиональные инструменты",
          item4: "Салонное оборудование",
          content2: "Все продукты изготовлены по высочайшим стандартам качества и проверены на безопасность."
        },
        section3: {
          title: "3. Заказы и Оплата",
          content1: "Заказ считается подтвержденным только после обработки платежа.",
          content2: "Мы принимаем оплату картой.",
          content3: "Цены указаны в грузинских лари (₾)."
        },
        section4: {
          title: "4. Доставка и Транспортировка",
          content1: "Доставка в Тбилиси занимает 1-2 рабочих дня.",
          content2: "Региональная доставка занимает 3-5 рабочих дней.",
        },
        section5: {
          title: "5. Возврат и Возмещение",
          content1: "Продукты могут быть возвращены при следующих условиях:",
          item1: "Продукт поврежден или дефектный",
          item2: "Был доставлен неправильный продукт",
          item3: "Возврат должен быть произведен в течение 14 дней с момента получения",
          content2: "Вскрытые и использованные продукты не могут быть возвращены из-за требований гигиены."
        },
        section6: {
          title: "6. Учетные записи пользователей",
          content1: "Создавая учетную запись, вы несете ответственность за безопасность ваших учетных данных.",
          content2: "Запрещено создавать или использовать учетную запись от имени другого лица.",
          content3: "В случае подозрительной активности мы оставляем за собой право заблокировать или удалить вашу учетную запись."
        },
        section7: {
          title: "7. Конфиденциальность и Защита Данных",
          content1: "Мы защищаем ваши персональные данные в соответствии с законодательством Грузии.",
          content2: "Для получения подробной информации ознакомьтесь с нашей Политикой конфиденциальности."
        },
        section8: {
          title: "8. Интеллектуальная Собственность",
          content1: "Весь контент, включая логотипы, изображения и текст, является собственностью BeautyPro.ge.",
          content2: "Использование любых материалов без письменного разрешения запрещено."
        },
        section9: {
          title: "9. Ограничение Ответственности",
          content1: "BeautyPro.ge не несет ответственности за косвенный ущерб, который может возникнуть в результате использования продуктов.",
          content2: "Наша ответственность ограничена стоимостью продукта."
        },
        section10: {
          title: "10. Контактная Информация",
          content1: "Если у вас есть вопросы, пожалуйста, свяжитесь с нами:",
          email: "Электронная почта",
          phone: "Телефон",
          address: "Адрес",
          addressValue: "Тбилиси, Грузия"
        },
        footer: "Прочитав и приняв эти условия, вы подтверждаете, что прочитали и согласны со всеми правилами и условиями BeautyPro.ge."
      },
      // Privacy Policy
      privacy: {
        title: "Политика Конфиденциальности",
        lastUpdated: "Последнее обновление",
        date: "Январь 2025",
        welcome: "В BeautyPro.ge мы стремимся защитить вашу конфиденциальность. Эта Политика конфиденциальности объясняет, как мы собираем, используем и защищаем вашу личную информацию.",
        section1: {
          title: "1. Информация, Которую Мы Собираем",
          content1: "Мы собираем следующие типы информации при использовании нашего веб-сайта:",
          subtitle1: "Личная информация:",
          item1: "Имя и контактные данные (электронная почта, телефон, адрес)",
          item2: "Платежная информация и адрес доставки",
          item3: "Информация о платежной карте (обработана безопасно)",
          item4: "Учетные данные (имя пользователя и пароль)",
          subtitle2: "Информация об использовании:",
          item5: "Посещенные страницы и просмотренные товары",
          item6: "Информация об устройстве (IP-адрес, тип браузера)",
          item7: "Файлы cookie и подобные технологии отслеживания"
        },
        section2: {
          title: "2. Как Мы Используем Вашу Информацию",
          content1: "Мы используем вашу личную информацию для следующих целей:",
          item1: "Обработка и выполнение ваших заказов",
          item2: "Общение с вами о ваших заказах и учетной записи",
          item3: "Улучшение нашего веб-сайта и обслуживания клиентов",
          item4: "Отправка рекламных писем (с вашего согласия)",
          item5: "Предотвращение мошенничества и обеспечение безопасности"
        },
        section3: {
          title: "3. Хранение и Безопасность Данных",
          content1: "Мы применяем стандартные отраслевые меры безопасности для защиты ваших персональных данных от несанкционированного доступа, раскрытия или неправомерного использования.",
          content2: "Ваша платежная информация шифруется с использованием технологии SSL и обрабатывается безопасными платежными провайдерами.",
          content3: "Мы храним ваши персональные данные только в течение периода, необходимого для выполнения целей, описанных в этой политике, или в соответствии с требованиями законодательства."
        },
        section4: {
          title: "4. Передача Вашей Информации",
          content1: "Мы не продаем и не сдаем в аренду вашу личную информацию третьим лицам. Мы можем передавать вашу информацию:",
          item1: "Платежным процессорам для завершения транзакций",
          item2: "Транспортным компаниям для доставки ваших заказов",
          item3: "Поставщикам услуг, которые помогают нам управлять нашим веб-сайтом",
          content2: "Все третьи стороны обязаны защищать ваши данные и использовать их только для целей, указанных нами."
        },
        section5: {
          title: "5. Файлы Cookie и Технологии Отслеживания",
          content1: "Мы используем файлы cookie и подобные технологии для:",
          item1: "Запоминания ваших предпочтений и настроек",
          item2: "Анализа трафика и моделей использования веб-сайта",
          item3: "Персонализации вашего опыта покупок",
          content2: "Вы можете управлять файлами cookie через настройки браузера. Отключение файлов cookie может повлиять на функциональность веб-сайта."
        },
        section6: {
          title: "6. Ваши Права",
          content1: "У вас есть следующие права в отношении ваших персональных данных:",
          item1: "Доступ: Запросить копию ваших персональных данных",
          item2: "Исправление: Обновить или исправить неточную информацию",
          item3: "Удаление: Запросить удаление ваших персональных данных",
          item4: "Возражение: Возразить против определенных действий по обработке данных",
          item5: "Портативность: Получить ваши данные в портативном формате",
          content2: "Для реализации этих прав, пожалуйста, свяжитесь с нами, используя информацию ниже."
        },
        section7: {
          title: "7. Конфиденциальность Детей",
          content1: "Наш веб-сайт не предназначен для детей младше 18 лет. Мы сознательно не собираем личную информацию от детей.",
          content2: "Если мы узнаем, что собрали информацию от ребенка, мы немедленно удалим ее."
        },
        section8: {
          title: "8. Ссылки на Сторонние Сайты",
          content1: "Наш веб-сайт может содержать ссылки на сторонние сайты. Мы не несем ответственности за практику конфиденциальности этих сайтов.",
          content2: "Мы рекомендуем вам ознакомиться с политикой конфиденциальности любых сторонних сайтов, которые вы посещаете."
        },
        section9: {
          title: "9. Изменения в Политике Конфиденциальности",
          content1: "Мы можем время от времени обновлять эту Политику конфиденциальности. Любые изменения будут опубликованы на этой странице с обновленной датой пересмотра.",
          content2: "Мы рекомендуем вам периодически просматривать эту политику, чтобы быть в курсе того, как мы защищаем вашу информацию."
        },
        section10: {
          title: "10. Свяжитесь с Нами",
          content1: "Если у вас есть вопросы или опасения по поводу этой Политики конфиденциальности, пожалуйста, свяжитесь с нами:",
          email: "Электронная почта",
          phone: "Телефон",
          address: "Адрес",
          addressValue: "Тбилиси, Грузия"
        },
        footer: "Используя BeautyPro.ge, вы соглашаетесь на сбор и использование вашей информации, как описано в этой Политике конфиденциальности."
      },
      // Return Policy
      returnPolicy: {
  title: "Политика возврата и возмещения средств",
  lastUpdated: "Последнее обновление",
  date: "Январь 2025",
  welcome:
    "В BeautyPro.ge удовлетворенность клиентов является нашим приоритетом. Мы предлагаем простую и прозрачную политику возврата, чтобы вы были уверены в своей покупке.",
  section1: {
    title: "1. Срок возврата",
    content1:
      "Клиент имеет право вернуть или обменять продукцию, приобретенную в Beauty Pro, в течение 14 календарных дней с момента доставки.",
    content2:
      "Срок возврата отсчитывается с даты фактического получения заказа.",
    important: "Важно:",
    content3:
      "Продукты должны быть возвращены в течение указанного 14-дневного срока для получения возврата средств или обмена."
  },
  section2: {
    title: "2. Условия обмена продукции",
    content1: "Продукция подлежит обмену в следующих случаях:",
    item1: "Продукт был доставлен поврежденным или с дефектом",
    item2: "Был доставлен неправильный товар",
    item3: "Продукт не соответствует описанию",
    item4:
      "Клиент решил обменять товар на аналогичную модель в течение 14 дней при условии, что продукт не вскрыт, не использован и сохраняет первоначальный товарный вид."
  },
  section3: {
    title: "3. Товары, не подлежащие возврату",
    content1:
      "По соображениям гигиены и безопасности следующие товары не подлежат возврату:",
    item1: "Вскрытые или использованные косметические продукты",
    item2: "Товары с поврежденными пломбами или упаковкой",
    item3: "Товары финальной распродажи или со скидкой",
    item4: "Подарочные карты или рекламная продукция"
  },
  section4: {
    title: "4. Как вернуть товар",
    content1:
      "Для возврата или обмена товара клиент обязан заранее связаться с информационной службой Beauty Pro и предоставить следующую информацию:",
    step1Title: "Номер заказа",
    step2Title: "Дата заказа и получения",
    step3Title: "Причина возврата"
  },
  section5: {
    title:
      "5. Beauty Pro обязуется вернуть уплаченную сумму на следующих условиях:",
    content1:
      "100% возврат — если товар не вскрыт, не поврежден и находится в полной комплектации",
    content2:
      "100% возврат — в случае производственного брака, неправильной доставки или повреждения при транспортировке",
    content3:
      "Частичный возврат (90–100%) — если упаковка вскрыта, но товар полностью исправен функционально и визуально",
    note:
      "Если в результате диагностики будет установлено, что товар утратил функциональные или визуальные характеристики либо отсутствует полная комплектация, Beauty Pro оставляет за собой право отказать в возврате.",
    content4:
      "Частичный возврат (60–80%) — если упаковка повреждена или имеются визуальные дефекты"
  },
  section6: {
    title: "6. Политика обмена",
    content1:
      "Маникюрная продукция не подлежит обмену. Политика возврата распространяется на все товары, за исключением лаков, гель-лаков и одноразовой продукции.",
    content2:
      "Обмен зависит от наличия товара на складе.",
    content3:
      "Отправка нового товара осуществляется после получения возвращенного продукта."
  },
  section7: {
    title: "7. Расходы на обратную доставку",
    content1:
      "Beauty Pro покрывает расходы на возвратную доставку, если:",
    item1: "Товар не соответствует заказу",
    item2:
      "Товар имеет производственный дефект или был поврежден при транспортировке"
  },
  section8: {
    title: "8. Процесс возврата средств",
    content1:
      "Возврат средств осуществляется только безналичным способом на тот же метод оплаты, который использовался при покупке.",
    content2:
      "Возмещение производится в течение 5 рабочих дней после получения и проверки возвращенного товара."
  },
  section9: {
    title: "9. Свяжитесь с нами для возврата",
    content1:
      "По любым вопросам или для начала процесса возврата, пожалуйста, свяжитесь с нами:",
    email: "Электронная почта",
    phone: "Телефон",
    hours: "Часы работы",
    hoursValue: "Понедельник – Суббота, 10:00 – 19:00"
  },
  footer:
    "Оформляя покупку на BeautyPro.ge, вы соглашаетесь с нашей политикой возврата и возмещения средств. Мы работаем для вашего комфорта!"
},
      about: {
        title: "О нас",
        welcome: "Beauty Pro Store — это премиальное пространство, объединяющее качество, эстетику и профессиональное видение. Наша платформа создана для тех, кто ценит качество и безупречный результат. Beauty Pro Store является официальным представителем KUKLA и представляет премиальные бренды, соответствующие высоким стандартам современной индустрии, обеспечивающие стабильные результаты и выстраивающие партнёрские отношения со специалистами и салонами на основе доверия, качества и эффективного сотрудничества."},
      shop: {
        next: "Вперед",
        previous: "Назад"
      },
      contact: {
        title: "Свяжитесь с нами",
        subtitle: "Свяжитесь с нами по любым вопросам. Наша команда готова помочь вам!",
        phone: "Телефон",
        email: "электронная почта",
        call: "Дозвониться →",
        send: "Отправить →",
        follow: "Подписаться →",
        visit: "Посетить →",
      },
      footer: {
        rights: "Все права защищены.",
        shop: "Магазин",
        contact: "Контакты",
        support: "Поддержка",
        terms: "Условия и положения",
        privacy: "Политика конфиденциальности",
        refund: "Политика возврата средств",
        collection: "Новая коллекция",
        location: "проспект Важа-Пшавела, II линия, здание 11B, Тбилиси, Грузия",
      },
      login: {
        title: "Вход",
        email: "Электронная почта",
        password: "Пароль",
        remember: "Запомнить меня",
        login: "Нет аккаунта?",
        loginLink: "Регистрация"
      },
      register: {
        title: "Создать аккаунт",
        subtitle: "Присоединяйтесь и начинайте покупки!",
        fullName: "Полное имя",
        email: "Электронная почта",
        password: "Пароль",
        confirmPassword: "Подтвердите пароль",
        agreeTerms: "Я соглашаюсь с ",
        haveAccount: "Уже есть аккаунт?",
        login: "Войти",
      },
      product: {
  availability: "Наличие",
  category: "Категория",
  inStock: "В наличии",
  outOfStock: "Нет в наличии",
  quantity: "Количество",
  addToCart: "Добавить в корзину",

  messages: {
    error: "Ошибка",
    productNotFound: "Товар не найден",
    productNotFoundDesc: "Товар, который вы ищете, не существует.",

    loginRequired: "Требуется вход",
    loginRequiredDesc: "Пожалуйста, войдите, чтобы добавить товары в корзину.",

    success: "Успешно",
    addedToCart: "Добавлено в корзину",
    addedToCartDesc: "добавлен в вашу корзину!",
  }
      }

    },
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ka', // Default to Georgian
    lng: localStorage.getItem('language') || 'ka', // Georgian as default
    
    interpolation: {
      escapeValue: false
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;